import React from 'react';
import { Text, Flex } from 'rebass/styled-components';
import styled from 'styled-components';

const StyledFlex = styled(Flex)`
  border-radius: 5px;
  background-color: RGBA(187, 60, 80, 0.11);
  padding: 10px;
  margin: 0px 0 10px 0;
`;

const StyledMessage = styled(Text)`
  font-size: 16px;
  font-weight: bold;
  color: #bb3c50;
`;

const Message = ({ message }) => {
  return (
    <StyledFlex>
      <StyledMessage>{message}</StyledMessage>
    </StyledFlex>
  );
};

export default Message;
